module.exports = __webpack_public_path__ + "static/media/22ESCWA7.204c3db1.jpg";